export const WHATSAPP = "5548996889862";
export const PHONE_DISPLAY = "(48) 99688-9862";
export const INSTAGRAM_URL = "https://www.instagram.com/vidracariagabibox/";
export const GOOGLE_URL = "https://share.google/yvXvODOx90SyxiNO0";

export const waLink = (msg = "Olá! Vim pelo site da Gabibox e gostaria de solicitar um orçamento.") =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`;

export const IMG = {
  logo: "/gabibox/logo.png",
  logoFull: "/gabibox/logo-full.png",
  boxDourado: "/gabibox/box-dourado.webp",
  boxPreto: "/gabibox/box-preto.webp",
  mesas: "/gabibox/mesas.webp",
  estoque: "/gabibox/estoque.webp",
  obraJanela: "/gabibox/obra-janela.webp",
  obraFachada: "/gabibox/obra-fachada.webp",
  obraCasa: "/gabibox/obra-casa.webp",
  obraPorta: "/gabibox/obra-porta.webp",
  shower: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showerLux: "https://images.unsplash.com/photo-1571781418606-70265b9cce90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mirror: "https://images.unsplash.com/photo-1595455967759-5f1356993e53?q=85&w=1200",
  glassDoor: "https://images.unsplash.com/photo-1636125657985-7384a5478f5a?q=85&w=1200",
  glassDoor2: "https://images.unsplash.com/photo-1525570665650-76bb26af503d?q=85&w=1200",
  facade: "https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade2: "https://images.unsplash.com/photo-1481026469463-66327c86e544?q=85&w=1200",
};

export const SERVICES = [
  {
    icon: "Bath",
    title: "Box para Banheiro",
    desc: "Projetos sob medida com diversos modelos, ferragens e acabamentos para sua residência ou empresa.",
    img: IMG.boxDourado,
    tag: "Sob medida",
  },
  {
    icon: "Sparkles",
    title: "Espelhos Sob Medida",
    desc: "Espelhos personalizados e decorativos para banheiros, salas, academias, quartos, closets e empresas.",
    img: IMG.mirror,
    tag: "Personalizado",
  },
  {
    icon: "Layers",
    title: "Vidro Temperado",
    desc: "Portas, divisórias, fechamentos, guarda-corpos e fachadas em vidro temperado certificado.",
    img: IMG.glassDoor,
    tag: "Certificado",
  },
  {
    icon: "Wrench",
    title: "Manutenção de Box",
    desc: "Troca de roldanas e puxadores, regulagem, vedação e substituição de peças com garantia.",
    img: IMG.boxPreto,
    tag: "Rápida",
  },
  {
    icon: "AppWindow",
    title: "Manutenção de Janelas",
    desc: "Correção de travamentos, regulagens e troca de componentes para janelas de vidro.",
    img: IMG.facade,
    tag: "Especializada",
  },
  {
    icon: "DoorOpen",
    title: "Manutenção de Portas de Vidro",
    desc: "Reposição de peças, regulagem e conserto completo de portas de vidro temperado.",
    img: IMG.glassDoor2,
    tag: "Conserto",
  },
];

export const DIFFERENTIALS = [
  { icon: "Zap", title: "Atendimento rápido" },
  { icon: "Users", title: "Equipe especializada" },
  { icon: "Hammer", title: "Instalação profissional" },
  { icon: "Sparkles", title: "Acabamento impecável" },
  { icon: "ShieldCheck", title: "Vidros certificados" },
  { icon: "Building2", title: "Residencial e comercial" },
  { icon: "PencilRuler", title: "Projetos personalizados" },
  { icon: "BadgeDollarSign", title: "Excelente custo-benefício" },
  { icon: "FileCheck2", title: "Orçamento sem compromisso" },
];

export const PORTFOLIO = [
  { src: IMG.boxDourado, title: "Box dourado sob medida", cat: "Box para Banheiro" },
  { src: IMG.obraCasa, title: "Fachada residencial em vidro", cat: "Fachada de Vidro" },
  { src: IMG.boxPreto, title: "Box preto em mármore", cat: "Box para Banheiro" },
  { src: IMG.obraPorta, title: "Porta e divisórias de vidro", cat: "Portas de Vidro" },
  { src: IMG.mesas, title: "Tampos e ambientes de vidro", cat: "Vidro Temperado" },
  { src: IMG.obraFachada, title: "Fachada comercial em vidro", cat: "Fachada de Vidro" },
  { src: IMG.obraJanela, title: "Fechamento de sacada", cat: "Fechamento em Vidro" },
  { src: IMG.estoque, title: "Vidros temperados certificados", cat: "Materiais" },
];

export const FEED = [
  IMG.boxDourado, IMG.boxPreto, IMG.mesas, IMG.obraCasa, IMG.obraFachada, IMG.obraPorta, IMG.obraJanela, IMG.estoque,
];

export const REVIEWS = [
  {
    name: "Mariana Oliveira",
    city: "São José",
    text: "Instalaram o box do meu banheiro com um acabamento impecável. Equipe pontual, educada e caprichosa. Recomendo demais!",
    initials: "MO",
  },
  {
    name: "Rafael Souza",
    city: "Florianópolis",
    text: "Fizeram a fachada de vidro da minha loja. Serviço de altíssima qualidade e prazo cumprido. Virei cliente fiel da Gabibox.",
    initials: "RS",
  },
  {
    name: "Juliana Martins",
    city: "Palhoça",
    text: "Precisava de espelhos sob medida para a academia e ficaram perfeitos. Atendimento rápido e preço justo.",
    initials: "JM",
  },
  {
    name: "Carlos Eduardo",
    city: "Biguaçu",
    text: "Troca de roldanas e regulagem do box resolvida no mesmo dia. Profissionais que entendem do assunto.",
    initials: "CE",
  },
  {
    name: "Fernanda Lima",
    city: "Florianópolis",
    text: "Divisórias de vidro temperado no escritório. Ambiente ficou moderno e sofisticado. Nota mil!",
    initials: "FL",
  },
  {
    name: "Diego Ramos",
    city: "Santo Amaro da Imperatriz",
    text: "Guarda-corpo de vidro na sacada com segurança e elegância. Melhor vidraçaria da Grande Florianópolis.",
    initials: "DR",
  },
];

export const CITIES = [
  "São José", "Florianópolis", "Palhoça", "Biguaçu",
  "Santo Amaro da Imperatriz", "Governador Celso Ramos", "Grande Florianópolis",
];
